export default {
  data() {
    return {
      tempheight: document.documentElement.clientHeight + 'px',
      tempwidth: document.documentElement.clientWidth - 30 + 'px'
    };
  }
};